import { mountPlayRoute } from './play-route';
import { mountLoadoutRoute } from './loadout-route';
import { mountCareerRoute } from './career-route';
import { mountQuestsRoute } from './quests-route';
import { mountLeaderboardsRoute } from './leaderboards-route';
import { mountShopRoute } from './shop-route';
import { mountSettingsRoute } from './settings-route';
import type { RouteMount } from './types';
import { DEFAULT_META_ROUTE } from '../routes';

/** One entry per item in `shell/routes.ts`'s `META_ROUTES` — keep the two lists in step. */
export const ROUTE_TABLE: Record<string, RouteMount> = {
  '/play': mountPlayRoute,
  '/loadout': mountLoadoutRoute,
  '/shop': mountShopRoute,
  '/career': mountCareerRoute,
  '/leaderboards': mountLeaderboardsRoute,
  '/quests': mountQuestsRoute,
  '/settings': mountSettingsRoute,
};

export function routeMountFor(path: string): RouteMount {
  return ROUTE_TABLE[path] ?? ROUTE_TABLE[DEFAULT_META_ROUTE];
}
